import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f7f7f7;
  width: 100%;
  height: calc(100% - 6rem);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
`;

export const Content = styled.hgroup`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex-direction: column;
  padding: 5rem 5rem 5rem 0;
  color: #333;

  h1 {
    font-weight: 500;
    font-size: 5rem;
  }

  h5 {
    font-weight: 400;
    font-size: 2rem;
  }
`;

export const Image = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    max-width: 30rem;
  }
`;
